import { useNavigate } from 'react-router-dom';

import { removeLocalStorageToken } from '../helpers/localStorage';

interface UseErrorMessageHook {
  getErrorMessage(error: unknown, navigateHome?: boolean): string;
  logDevError(error: unknown): void;
}

export default function useErrorMessage(): UseErrorMessageHook {
  const navigate = useNavigate();

  const getErrorMessage = (error: unknown, navigateHome?: boolean): string => {
    if (error instanceof Error) {
      if (error.name === 'TypeError') {
        return 'Algo deu errado, tente novamente';
      }
      if (error.message === 'Sessão inválida') {
        removeLocalStorageToken();
        navigate('/login');
      } else if (navigateHome) {
        navigate('/home');
      }
      return error.message;
    }
    return 'Algo deu errado, tente novamente';
  };

  const logDevError = (error: unknown): void => {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(error);
    }
  };

  return {
    getErrorMessage,
    logDevError,
  };
}
